"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upperModulo = void 0;
const upperModulo = (value, trackId, modulo) => {
    const lower = modulo.times(value.div(modulo).integerValue());
    const lowerPlusTrack = lower.plus(trackId);
    if (value.lte(lowerPlusTrack))
        return lowerPlusTrack;
    return lowerPlusTrack.plus(modulo);
};
exports.upperModulo = upperModulo;
//# sourceMappingURL=modulo.js.map